import invariant from 'tiny-invariant'

type SavedIdPair = { temporaryId: string; savedId: string }

export const toSavedId =
  (pairs: SavedIdPair[]) =>
  (temporaryId: string): string => {
    const savedId = pairs.find(m => m.temporaryId === temporaryId)?.savedId
    invariant(savedId, `savedId not found for ${temporaryId}`)
    return savedId
  }

export const isSavedIdPair = (p: unknown): p is SavedIdPair => Boolean(p)
